// src/components/GoogleOneTapLogin.js
import { useGoogleOneTapLogin } from "@react-oauth/google";
import { GoogleAuthProvider, signInWithCredential } from "firebase/auth";
import { auth } from "../../firebase";

const GoogleOneTapLogin = () => {
  useGoogleOneTapLogin({
    onSuccess: async (credentialResponse) => {
      try {
        const credential = GoogleAuthProvider.credential(
          credentialResponse.credential
        );
        await signInWithCredential(auth, credential);
        console.log("✅ Firebase login via Google One Tap");
        // navigate(from);
      } catch (err) {
        console.error("Fejl ved One Tap login:", err);
      }
    },
    onError: () => {
      console.error("❌ One Tap login mislykkedes");
    },
    promptMomentNotification: (notification) => {
      if (notification.isNotDisplayed()) {
        console.warn(
          "One Tap blev ikke vist:",
          notification.getNotDisplayedReason()
        );
      }
    },
  });

  return null; // One Tap er usynlig
};

export default GoogleOneTapLogin;
